(function () {
  const sections = document.querySelectorAll('[data-abo-section]');
  if (!sections.length) return;

  sections.forEach((root) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (!entry.isIntersecting) return;
          setTimeout(() => entry.target.classList.add('fabo-is-visible'), index * 70);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
    );

    root.querySelectorAll('.fabo-reveal').forEach((item) => observer.observe(item));
  });
})();
